import { render, staticRenderFns } from "./NavigationWrapper.vue?vue&type=template&id=2a41135a&scoped=true&"
import script from "./NavigationWrapper.vue?vue&type=script&lang=js&"
export * from "./NavigationWrapper.vue?vue&type=script&lang=js&"
import style0 from "./NavigationWrapper.vue?vue&type=style&index=0&id=2a41135a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a41135a",
  null
  
)

export default component.exports